import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useImperativeHandle } from 'react';
import { Flex, Typography } from 'antd';
import axios from "axios";
import ConsignmentImageKind from "../../enums/ConsignmentImageKind";
import ImageGalleryLightbox from "../../components/ImageGalleryLightbox";
import API from "../../../../API";
import { ImageLoader } from "../../components/ImageLoader";
const ConsignmentPhotoList = React.forwardRef((props, exportedRef) => {
    const [stateLoading, setStateLoading] = React.useState(false);
    const [stateImages, setStateImages] = React.useState([]);
    const [stateLightBoxOpen, setStateLightBoxOpen] = React.useState(false);
    const [statePhotoIndex, setStatePhotoIndex] = React.useState(0);
    useImperativeHandle(exportedRef, () => ({
        refresh: () => {
            loadConsignmentImages();
        }
    }));
    useEffect(() => {
        loadConsignmentImages();
    }, [props.consignmentId, props.consignmentVersion]);
    const loadConsignmentImages = () => {
        let consignmentId = props.consignmentId;
        if (!props.consignmentId) {
            return;
        }
        setStateLoading(true);
        axios.get(`/admin/v1/consignments/${consignmentId}/images`).then(response => {
            const images = response.data.results
                .filter((item) => {
                if (!props.filterKind || props.filterKind.length < 1) {
                    return true;
                }
                const imageKind = ConsignmentImageKind.valueOf(item.kind);
                return props.filterKind.indexOf(imageKind) >= 0;
            })
                .map((item) => {
                return {
                    id: item.id,
                    kind: ConsignmentImageKind.fromString(item.kind),
                    comments: item.comments,
                    url: `${API.origin()}/admin/v1/consignments/${consignmentId}/images/${item.id}/content`,
                    thumbUrl: `${API.origin()}/admin/v1/consignments/${consignmentId}/images/${item.id}/thumbnail`
                };
            });
            setStateImages(images);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const openLightBox = (imageId) => {
        const index = stateImages.findIndex(item => item.id === imageId);
        setStateLightBoxOpen(true);
        setStatePhotoIndex(index);
    };
    return (_jsxs("div", { style: {
            maxHeight: 400,
            overflow: 'auto',
            padding: '0 16px 0 0', // Cater for the vert scrollbar, without this a horizontal scrollbar will appear
        }, children: [_jsx(Flex, { vertical: true, gap: 8, children: stateImages.map((item) => (_jsxs(Flex, { gap: 16, children: [_jsx("a", { onClick: () => openLightBox(item.id), children: _jsx(ImageLoader, { src: item.thumbUrl, alt: item.kind?.description }) }), _jsxs(Flex, { vertical: true, children: [_jsx(Typography.Text, { strong: true, children: item.kind?.description }), _jsx(Typography.Text, { type: "secondary", children: item.comments }), props.renderActions?.(item)] })] }))) }), _jsx(ImageGalleryLightbox, { open: stateLightBoxOpen, initialIndex: statePhotoIndex, images: (stateImages || []).map(it => {
                    return {
                        url: it.url,
                        title: it.kind?.description,
                        caption: it.comments
                    };
                }), onClose: () => {
                    setStateLightBoxOpen(false);
                } })] }));
});
export default ConsignmentPhotoList;
